import React from 'react'
import { useMediaPredicate } from 'react-media-hook'
import { PrismicRichText } from '@prismicio/react'

import { DEVICE } from '../../util/constants'
import * as Styled from './styles/AdvanceLandingHero.styles'

const AdvanceLandingHero = ({ header, heroText }) => {
  const tabletAndUp = useMediaPredicate(DEVICE.tabletL)

  return (
    <Styled.GridContainer>
      <Styled.AdvanceLandingHero>
        <Styled.TextColumn>
          <Styled.HeroTextRegion>
            <Styled.CenteredTextColumn>
              <Styled.HeroTitle>
                <PrismicRichText field={header.richText} />
              </Styled.HeroTitle>
              <Styled.HeroText>
                <PrismicRichText field={heroText.richText} />
              </Styled.HeroText>
            </Styled.CenteredTextColumn>
          </Styled.HeroTextRegion>
        </Styled.TextColumn>
      </Styled.AdvanceLandingHero>
    </Styled.GridContainer>
  )
}

export default AdvanceLandingHero
